<template>
    <div class="model-portfolio-positions">
        <horizontal-scrolling-container
            wrapper-class="model-portfolio-positions__table-wrapper"
            content-class="model-portfolio-positions__table">
            <b-table-simple
                :fixed="viewportIsLarge"
                class="table">
                <b-thead>
                    <b-tr>
                        <b-th v-if="!viewportIsLarge">
                            <span class="d-block">{{ $t(`modelPortfolioPositions.header.${columnNames[3]}`) }}</span>
                        </b-th>
                        <b-th>{{ $t(`modelPortfolioPositions.header.${columnNames[0]}`) }}</b-th>
                        <b-th>{{ $t(`modelPortfolioPositions.header.${columnNames[1]}`) }}</b-th>
                        <b-th>{{ $t(`modelPortfolioPositions.header.${columnNames[2]}`) }}</b-th>
                        <b-th v-if="viewportIsLarge">
                            <span class="d-block">{{ $t(`modelPortfolioPositions.header.${columnNames[3]}`) }}</span>
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr
                        v-for="(item, index) in this.slicedRows"
                        :key="`positionsTableRow-${index}`">
                        <b-td v-if="!viewportIsLarge">
                            <span class="d-block model-portfolio-positions__description">{{ item[columnNames[3]] }}</span>
                            <span class="d-block model-portfolio-positions__isin">{{ item[columnNames[4]] }}</span>
                        </b-td>
                        <b-td :class="{'marked': isMarked(DetailsFilterType.ASSET_CLASS)}">
                            {{ item[columnNames[0]] }}
                        </b-td>
                        <b-td :class="{'marked': isMarked(DetailsFilterType.CURRENCY)}">
                            {{ item[columnNames[1]] }}
                        </b-td>
                        <b-td :class="{'marked': isMarked(DetailsFilterType.REGION)}">
                            {{ item[columnNames[2]] }}
                        </b-td>
                        <b-td v-if="viewportIsLarge" sticky-column>
                            <span class="d-block model-portfolio-positions__description">{{ item[columnNames[3]] }}</span>
                            <span class="d-block model-portfolio-positions__isin">{{ item[columnNames[4]] }}</span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </horizontal-scrolling-container>
        <b-button
            variant="link"
            class="btn text-decoration-none"
            :class="{
                'collapsed': isCollapsed,
            }"
            @click="isCollapsed = !isCollapsed">
            <Icon
                class="icon collapsible__icon--opened"
                :type="'chevron-up-bold'"
                :width="14"
                :height="9" />
            <Icon
                class="icon collapsible__icon--closed"
                :type="'chevron-down-bold'"
                :width="14"
                :height="9" />
            <span>{{ isCollapsed ? $t('modelPortfolioPositions.link.label.collapsed') : $t('modelPortfolioPositions.link.label.contracted') }}</span>
        </b-button>
    </div>
</template>

<script>
import { DetailsFilterType } from '@/api/enums';
import { mapGetters, mapState } from 'vuex';
import HorizontalScrollingContainer from '@/components/common/HorizontalScrollingContainer';

export default {
    name: 'ModelPortfolioPositions',
    components: {
        HorizontalScrollingContainer,
    },
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ...mapState(['selectedDetailsFilterType']),
        ...mapGetters(['viewportIsLarge']),
        slicedRows () {
            return this.isCollapsed ? this.rows : this.rows.slice(0, 3);
        },
        isMarked () {
            return detailsFilterType => this.selectedDetailsFilterType === detailsFilterType;
        },
    },
    data () {
        return {
            DetailsFilterType,
            columnNames: ['assetGroup', 'currency', 'region', 'description', 'isin'],
            isCollapsed: false,
        };
    },
};
</script>

<style scoped lang="scss">

.marked {
  background: $mb-grey2;
  font-weight: bold;
}

.model-portfolio-positions {
  font-size: 15px;

  thead {

    tr {
      height: 32px;
      th {
        border-bottom: 1px solid $mb-grey5;
        border-right: 1px solid $mb-grey5;
        border-top: none;

        &:last-child {
          border-right: none;
        }
      }
    }
  }

  tbody {
    tr {
      height: 32px;
      &:last-child {
        border-bottom: 1px solid $mb-grey5;
      }
    }
  }
}

.table {
 margin-bottom: 0;
}

.table th, .table td {
  vertical-align: middle;
  padding: 0;
  padding-left: 15px;
  padding-right: 20px;

  &:nth-child(1) {
    width: 145px;
    white-space: nowrap;
  }

  &:nth-child(2) {
    width: 100px;
    white-space: nowrap;
  }

  &:nth-child(3) {
    width: 145px;
    white-space: nowrap;
  }

  &:nth-child(4) {
    white-space: nowrap;
  }

  @include media-breakpoint-down(xs) {
    &:nth-child(1) {
        white-space: normal;
        padding-right: 15px;
    }

    &:nth-child(2) {
      white-space: nowrap;
    }

    &:nth-child(3) {
      white-space: nowrap;
    }

    &:nth-child(4) {
      white-space: nowrap;
      padding-right: 20px;
    }
  }
}

.table th {
  padding-right: 20px;

  &:nth-child(1) {
    @include media-breakpoint-down(xs) {
      padding-right: 200px;
    }
  }
}

.collapsed > .collapsible__icon--closed,
:not(.collapsed) > .collapsible__icon--opened {
  display: none;
}

.btn {
  @include font-migrosbank();
  line-height: 17px;
}

.btn-link {
  ::v-deep path {
    stroke: $mb-darkgreen;
  }

  &:hover {
    background: transparent;
    color: $mb-lightgreen;

    ::v-deep path {
      stroke: $mb-lightgreen;
    }
  }
}

.model-portfolio-positions__isin {
  font-weight: normal;
  font-size: 12px;
  line-height: 1;
  padding-bottom: 2px;
}

.model-portfolio-positions__description {
  line-height: 1;
  padding: 2px 0 2px 0;
}

</style>
